"use client";
import { jsx } from "react/jsx-runtime";
import "../../../foundation/iconography/ExtraIconsProvider.js";
import "../../../foundation/iconography/IconVariantProvider.js";
import "../../../foundation/iconography/icons.js";
import "../../../foundation/iconography/Icon.js";
import { BodyText } from "../../../foundation/typography/index.js";
import { forwardRef, createElement } from "react";
import classNames from "classnames";
import "../../../foundation/logos/Logo.css.js";
import { stateLayers } from "../../../styles/states.css.js";
import { buttonRecipe, actionText, textButtonText } from "./styles.css.js";
const TextButton = forwardRef(function TextButton2({ $as, as, className, underline, ...props }, ref) {
  return createElement($as ?? as ?? "button", {
    ...props,
    ref,
    className: classNames(className, buttonRecipe({ color: "transparent", buttonType: "text" }), stateLayers({
      borderSize: "medium",
      borderRadius: "button",
      backgroundColor: "palette-black",
      setFocusState: true
    }))
  }, props.children ? jsx(BodyText, { className: classNames(actionText, textButtonText({ underline })), children: props.children }) : void 0);
});
export {
  TextButton
};
